import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import { OverlayProvider } from 'overlay-kit';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<HelmetProvider>
		<BrowserRouter basename="/">
			<OverlayProvider>
				<App />
			</OverlayProvider>
		</BrowserRouter>
	</HelmetProvider>
);
